'use client';
import { type AvatarProps, Avatar as AvatarBase } from '@shared/ui-components';

import { imageLoader } from '../image-wrapper/image-loader';

export const Avatar = (props: AvatarProps) => {
  return <AvatarBase {...props} loader={imageLoader} />;
};
